<template>
  <v-container>
    <v-row>
      <v-col class="main" col="12" md="12" sm="12">
        <h1 style="text-align: center;">ขอบคุณที่สนใจครับ</h1>
        <!-- <h1 style="text-align: center;">กรุณา Login</h1> -->
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data () {
    return {}
  },
  mounted () {}
}
</script>



// WEBPACK FOOTER //
// src/components/Welcome/RegisterClose.vue